import { EVENT_PREFIX } from 'cpool-constants';
import { BadRequestError } from 'cpool-utils';
import type { ZodSchema } from 'zod';
import { z } from 'zod';

export abstract class _Event {
    payload: ReturnType<this['validate']>;

    type!: string;

    deprecated: boolean;

    abstract getSchema(): ZodSchema;

    getCensoredSchema(): ZodSchema {
        return this.getSchema();
    }

    getCensoredSchemaApplicant2Only(_applicant2Id: string): ZodSchema {
        return this.getSchema();
    }

    constructor(payload: unknown = {}, deprecated = false) {
        this.toString = this.constructor.toString.bind(this.constructor);

        this.payload = this.validate(payload);
        this.deprecated = deprecated;

        Object.defineProperty(this, 'type', {
            enumerable: true,
            get: () => this.toString(),
        });
    }

    validate(input: unknown): z.infer<ReturnType<this['getSchema']>> {
        const schema = this.getSchema();
        try {
            const payload = schema.parse(input);
            return payload;
        } catch (e: unknown) {
            if (e instanceof z.ZodError) {
                throw new BadRequestError(JSON.stringify(e));
            }
            // @ts-expect-error
            throw new BadRequestError(e);
        }
    }

    static getType() {
        return EVENT_PREFIX + this.name;
    }

    static toString() {
        return this.getType();
    }

    toJSON(): { deprecated: boolean; payload: unknown; type: string } {
        return {
            deprecated: this.deprecated,
            payload: this.payload,
            type: this.type,
        };
    }
}
